import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AngularFireFunctions} from '@angular/fire/compat/functions';


const ASAAS_URL = 'https://us-central1-sbccv-proj.cloudfunctions.net/asaasActionDev';

@Injectable({
  providedIn: 'root'
})
export class AsaasWebhookTestService {

  constructor (private _http: HttpClient,
    private fns: AngularFireFunctions
  ) { }

  async asaasAction (payload: any): Promise<any> {
    const headers = {
      'Content-Type': 'application/json',
    };

    try {
      const response: any = await this._http.post(ASAAS_URL, payload, {headers}).toPromise();
      return response;
    } catch (error) {
      console.log('Erro em asaasActionk:', error.status);
      return error.status;
    }
  }

  async testPaymentReceivedWebhook (webhookUrl: string): Promise<any> {
    // Simula um payload de pagamento recebido do Asaas
    const mockPaymentPayload = {
      event: 'PAYMENT_RECEIVED',
      payment: {
        id: 'pay_123456789',
        customer: 'cus_000005784631',
        billingType: 'BOLETO',
        value: 100.50,
        netValue: 98.50,
        status: 'RECEIVED',
        dueDate: '2023-12-25',
        originalDueDate: '2023-12-25',
        paymentDate: new Date().toISOString(),
        invoiceUrl: 'https://www.sandbox.asaas.com/invoice/123456789',
      },
      // Outros campos que podem ser relevantes
    };

    // Configura os headers (simulando o que o Asaas enviaria)
    const headers = {
      'Content-Type': 'application/json',
      // Adicione sua assinatura de webhook aqui, se necessário para testes
      'asaas-signature': '87963456-7de8-4572-aec2-72414849ed0a'
    };

    try {
      const response = await this._http.post(webhookUrl, mockPaymentPayload, {headers}).toPromise();
      console.log('Resposta do webhook:', response);
      return response;
    } catch (error) {
      console.error('Erro ao testar webhook:', error);
      throw error;
    }
  }

  async testPaymentConfirmedWebhook (webhookUrl: string): Promise<any> {
    // Simula um payload de pagamento confirmado do Asaas
    const mockPaymentPayload = {
      event: 'PAYMENT_CONFIRMED',
      payment: {
        id: 'pay_987654321',
        customer: 'cus_000005784632',
        billingType: 'CREDIT_CARD',
        value: 250.75,
        netValue: 245.25,
        status: 'CONFIRMED',
        dueDate: '2023-12-20',
        originalDueDate: '2023-12-20',
        paymentDate: new Date().toISOString(),
      },
    };

    const headers = {
      'Content-Type': 'application/json',
      'asaas-signature': '87963456-7de8-4572-aec2-72414849ed0a'
    };

    try {
      const response = await this._http.post(webhookUrl, mockPaymentPayload, {headers}).toPromise();
      console.log('Resposta do webhook:', response);
      return response;
    } catch (error) {
      console.error('Erro ao testar webhook:', error);
      throw error;
    }
  }

  async _simulateWebhookAction (): Promise<any> {
    // Simula um payload de pagamento confirmado do Asaas
    try {
      const headers = {
        'Content-Type': 'application/json',
        'access_token': '$aact_hmlg_000MzkwODA2MWY2OGM3MWRlMDU2NWM3MzJlNzZmNGZhZGY6OjM4OTk4YjBiLWNhZDItNDAzZi05YWVjLTM5YjE3NWU0YmZmYzo6JGFhY2hfMWY5OGE4MWMtNjYxZi00NTJhLWFkN2ItNDMzYTBiZDMxYjI5'
      };

      const id = "pay_fqjbv6yf2e042cq5";
      const endPoint = `https://sandbox.asaas.com/api/v3/payments/${ id }/simulate`;

      // O segundo parâmetro é o corpo da requisição (pode ser um objeto vazio para POST)
      // O terceiro parâmetro são as opções, onde os headers são definidos
      const response = await this._http.post(endPoint, {}, {headers}).toPromise();

      console.log('Resposta do webhook:', response);
      return response;
    } catch (error) {
      console.error('Erro ao testar webhook:', error);
      throw error;
    }
  }

  async simulateWebhookAction (): Promise<any> {
    try {
      const paymentId = "pay_i6861b59p5nrfg90";
      const callable = this.fns.httpsCallable('simulateWebHookAsaas');
      const response = await callable({paymentId}).toPromise();
      console.log('Resposta da função:', response);
      return response;
    } catch (error) {
      console.error('Erro ao chamar a função:', error);
      throw error;
    }
  }

}
